import React from 'react';

// https://www.npmjs.com/package/react-d3-tree

// https://bkrem.github.io/react-d3-tree/docs/interfaces/_src_tree_types_.treeprops.html

import Tree from 'react-d3-tree';
import './custom-tree.css';

import { useQuery } from "react-query";

import { fetchArborescenceGestionBrute } from 'utils/queries';


import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';


import { ArborescenceGestionNiveaux } from 'constants.js';

const PathFuncs = ["diagonal", "elbow", "straight", "step"]
const Orientations = ["horizontal", "vertical"]

//const renderRectSvgNode = ({ nodeDatum, toggleNode }) => (
//    <g>
//        <rect width="20" height="20" x="-10" onClick={toggleNode} />
//        <text fill="black" strokeWidth="1" x="20">
//            {nodeDatum.name}
//        </text>
//        {nodeDatum.attributes?.department && (
//            <text fill="black" x="20" dy="20" strokeWidth="1">
//                Department: {nodeDatum.attributes?.department}
//            </text>
//        )}
//    </g>
//);

// pour l'utiliser :  renderCustomNodeElement={renderRectSvgNode}


const AdministrationArborescenceDeveloppeur = () => {

    const [graphData, setGraphData] = React.useState({});
    const [pathFunc, setPathFunc] = React.useState(0);
    const [orientation, setOrientation] = React.useState(0);

    const { isLoading, isError, error, data } =
        useQuery({
            queryKey: [
                'arborescenceGestionBrute'
            ],
            queryFn: () => fetchArborescenceGestionBrute({}),
            keepPreviousData: true,
        })


    React.useEffect(() => {

        console.log("USE EFFECT DATA");

        if (!isLoading
            && !isError
            && data
        ) {
            console.log("data", data);

            const groupes = data.filter(x => x.niveau === ArborescenceGestionNiveaux.Groupe).map(x => {
                return ({
                    position: Number(x.libelle.substring(0, x.libelle.indexOf(' '))),
                    ...x
                });
            }).sort((a, b) => a.position > b.position);

            console.log("groupes", groupes);

            const sousGroupes = data.filter(x => x.niveau === ArborescenceGestionNiveaux.SousGroupe).map(x => {
                return ({
                    position: Number(x.libelle.substring(0, x.libelle.indexOf(' '))),
                    ...x
                });
            }).sort((a, b) => a.position > b.position);

            console.log("sousGroupes", sousGroupes);

            const graphData = {
                name: 'Arborescence',
                children: groupes.map(x => {

                    return ({

                        name: x.libelle,
                        attributes: {
                            //department: 'Production'
                        },
                        children: sousGroupes.filter(sg => sg.codeParent === x.code).map(sg => {

                            return ({

                                name: sg.libelle,
                                attributes: {
                                    //department: 'Production'
                                },
                                children: []

                            });
                        })

                    });
                })
            }


            //let nodes = data.filter(x => x.niveau === ArborescenceGestionNiveaux.Groupe || x.niveau === ArborescenceGestionNiveaux.SousGroupe || x.niveau === ArborescenceGestionNiveaux.Famille).map(x => {
            //    return ({
            //        id: x.niveau + '-' + x.code,
            //        name: x.libelle,
            //        val: valeurNiveau(x.niveau),

            //        visibility: true,
            //        //visibility: x.niveau === ArborescenceGestionNiveaux.Groupe,
            //        selected: false,

            //        ...x
            //    });
            //});

            //let origine = {
            //    id: 'ORIGINE',
            //    name: '.',
            //    val: 1,
            //    visibility: false,
            //    niveau: null,
            //    selected: false
            //}

            //nodes = [origine, ...nodes];


            //const links = data.filter(x => x.niveau === ArborescenceGestionNiveaux.Groupe || x.niveau === ArborescenceGestionNiveaux.SousGroupe || x.niveau === ArborescenceGestionNiveaux.Famille).map(x => {
            //    return ({
            //        source: x.niveauParent ? x.niveauParent + '-' + x.codeParent : 'ORIGINE',
            //        target: x.niveau + '-' + x.code,
            //        visibility: !!x.niveauParent
            //    });
            //});


            //console.log("nodes", nodes);
            //console.log("links", links);

            console.log("graphData", graphData);

            setGraphData(graphData);
        }

    }, [data]);

    const orgChart = {
        name: 'CEO',
        children: [
            {
                name: 'Manager',
                attributes: {
                    department: 'Production',
                },
                children: [
                    {
                        name: 'Foreman',
                        attributes: {
                            department: 'Fabrication',
                        },
                        children: [
                            {
                                name: 'Worker',
                            },
                        ],
                    },
                    {
                        name: 'Foreman',
                        attributes: {
                            department: 'Assembly',
                        },
                        children: [
                            {
                                name: 'Worker',
                            },
                        ],
                    },
                ],
            },
        ],
    };



    return (
        <>
            <Typography gutterBottom variant="h5">
                Arborescence gestion
            </Typography>


            <Stack direction={'row'}>
                <Box sx={{ width: '200px' }}>
                    <TextField
                        select
                        name="Chemins"
                        label="Forme des chemins"
                        value={pathFunc}
                        onChange={e => setPathFunc(e.target.value)}
                        fullWidth
                    >
                        {PathFuncs.map((pf, index) => (
                            <MenuItem key={index} value={index}>
                                {pf}
                            </MenuItem>
                        ))}
                    </TextField>
                </Box>

                <Box sx={{ width: '200px' }}>
                    <TextField
                        select
                        name="Orientation"
                        label="Orientation"
                        value={orientation}
                        onChange={e => setOrientation(e.target.value)}
                        fullWidth
                    >
                        {Orientations.map((o, index) => (
                            <MenuItem key={index} value={index}>
                                {o}
                            </MenuItem>
                        ))}
                    </TextField>
                </Box>
            </Stack>



            {isLoading ? (
                <div>Chargement...</div>
            ) : isError ? (
                <div>Erreur: {error.message}</div>
            ) : (
                <span></span>
            )}

            <Paper>

                {data ? (

                    <div id="treeWrapper" style={{ width: '100%', height: '50em' }}>
                        <Tree
                            data={graphData}
                            pathFunc={PathFuncs[pathFunc]}
                            orientation={Orientations[orientation]}
                            initialDepth={1}

                            rootNodeClassName="node__root"
                            branchNodeClassName="node__branch"
                            leafNodeClassName="node__leaf"

                            onNodeClick={(node, event) => { console.log("onNodeClick", node); }}

                            separation={{ nonSiblings: 4, siblings: 1 }}
                        />
                    </div>

                ) : <span>...</span>
                }

            </Paper>


        </>

        );

};





//AdministrationArborescenceDeveloppeur.propTypes = {
//};

export default AdministrationArborescenceDeveloppeur;